import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
    globalStore
} from '../helpers';

export const employeeService = {
    getById,
    save,
    get
};

function get() {
    const requestOptions = {
        headers: authHeader()
    };    
    return axios.get(`employee`, requestOptions).then(handleResult).catch(handleException);
}

function getById(userId) {
    const requestOptions = {
        headers: authHeader()
    };    
    return axios.get(`employee/${userId}`, requestOptions).then(handleResult).catch(handleException);
}

function save(employee) {
    const requestOptions = {
        headers: authHeader()
    };

    if(!employee.id || employee.id == 0) {
        return axios.post("employee", employee, requestOptions).then(handleResult).catch(handleException);
    }

    return axios.patch("employee/" + employee.id, employee, requestOptions).then(handleResult).catch(handleException);
}